export const WARRANTIES_TYPES = [
  {
    'key': 'TODOS',
    'text': 'TODOS',
    'value': 'TODOS',
  },
  {
    'key': 'VE',
    'text': 'VEHÍCULOS (VE)',
    'value': 'VE',
  },
  {
    'key': 'AC',
    'text': 'ACCESORIOS (AC)',
    'value': 'AC',
  },
  {
    'key': 'P1',
    'text': 'REPUESTOS (P1)',
    'value': 'P1',
  },
  {
    'key': 'P2',
    'text': 'REPUESTOS (P2)',
    'value': 'P2',
  },
  {
    'key': 'EX',
    'text': 'EXTENDIDAS (EX)',
    'value': 'EX',
  },
  {
    'key': 'CE',
    'text': 'CERTIFICADAS (CE)',
    'value': 'CE',
  },
];

export const WARRANTIES_TYPES_OBJECT = {
  'VE': 'VEHÍCULOS (VE)',
  'AC': 'ACCESORIOS (AC)',
  'P1': 'REPUESTOS (P1)',
  'P2': 'REPUESTOS (P2)',
  'EX': 'EXTENDIDAS (EX)',
  'CE': 'CERTIFICADAS (CE)',
};

export const WARRANTIES_OPERATION_TYPES = [
  {
    'key': 1,
    'text': 'General',
    'value': 1,
  },
  {
    'key': 2,
    'text': 'Paint',
    'value': 2,
  },
  {
    'key': 3,
    'text': 'Noise',
    'value': 3,
  },
  {
    'key': 4,
    'text': 'Rain',
    'value': 4,
  },
  {
    'key': 5,
    'text': 'Campaign',
    'value': 5,
  },
  {
    'key': 6,
    'text': 'Stock Disposal (for Dlr stock)',
    'value': 6,
  },
  {
    'key': 7,
    'text': 'Stock Disposal (for Dist stock)',
    'value': 7,
  },
];

export const PAYCODE_OPTIONS = [
  {
    'key': 0,
    'text': 'Pay to Dealer, Claim to Vendor',
    'value': 0,
  },
  {
    'key': 1,
    'text': 'Pay to Dealer, Not claim to Vendor',
    'value': 1,
  },
  {
    'key': 2,
    'text': 'Not pay to Dealer, Not claim to Vendor',
    'value': 2,
  },
];

export const warranties = {
  'hour_price': 25,
};
